import { useEffect, useState } from 'react';
import { Switch, useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PrivateRoute, PrivateRouteAdmin } from 'protectedRoute';

import { NAVIGATION } from 'common/constants';
// import WarningModal from 'components/WarningModal';

import Dashbord from 'containers/Dashboard';
import AuthStore from 'common/authStore';
// import { useCallback } from 'react';

import ErrorPage from 'containers/ErrorPage';
import QuestionCategory from 'containers/QuestionCategory/index.js';
import Questions from 'containers/Questions';
import Download from 'containers/Download';
import WarningModal from 'components/WarningModal';
import AccountSettings from 'containers/AccountSettings';
import Reports from 'containers/Reports';
// import StaticSurveyInfoPage from 'containers/SurveyInfo';
import ManageQuestions from 'containers/ManageQuestions';
import { decrypt } from 'utils/functions';
import NotFound from 'components/NotFound';

function Routes() {
  const location = useLocation();
  // const dispath = useDispatch();
  const history = useHistory();
  const [tokenToUse, updateToken] = useState(AuthStore.accessToken);
  const usertypestr = localStorage.getItem('usertype');

  let usertype = null;
  if (usertypestr && usertypestr != '') {
    usertype = decrypt(usertypestr);
  }

  useEffect(() => {
    if (!tokenToUse && AuthStore.accessToken) {
      updateToken(AuthStore.accessToken);
    }
    // eslint-disable-next-line
  }, [AuthStore.accessToken]);

  useEffect(() => {
    if (tokenToUse && location.pathname === NAVIGATION.Login) {
      history.push(NAVIGATION.HomePage);
    }
    // eslint-disable-next-line
  }, [tokenToUse]);

  const hasError = useSelector((state) => state.auth.isError);
  const errorDetails = useSelector((state) => state.auth.errorDetails);
  const tokenExpired = useSelector((state) => state.auth.tokenExpired);

  if (hasError) {
    return <ErrorPage errorDetails={errorDetails} isAuthorized={false} />;
  }

  return (
    <>
      {tokenExpired && <WarningModal />}
      <div className={`App ${tokenExpired && 'disabled-content'}`}>
        <Switch>
          <PrivateRoute
            path={NAVIGATION.HomePage}
            token={tokenToUse}
            component={usertype == 1 ? Dashbord : Reports} //StaticSurveyInfoPage
            exact
          />
          <PrivateRouteAdmin
            path={NAVIGATION.category}
            token={tokenToUse}
            component={QuestionCategory}
            exact
          />
          <PrivateRouteAdmin
            path={NAVIGATION.question}
            token={tokenToUse}
            component={Questions}
            exact
          />
          <PrivateRouteAdmin
            path={NAVIGATION.download}
            token={tokenToUse}
            component={Download}
            exact
          />
          <PrivateRoute path={NAVIGATION.insight} token={tokenToUse} component={Reports} exact />
          <PrivateRouteAdmin
            path={NAVIGATION.managequestions}
            token={tokenToUse}
            component={ManageQuestions}
            exact
          />
          <PrivateRoute
            path={NAVIGATION.settings}
            token={tokenToUse}
            component={AccountSettings}
            exact
          />
          <PrivateRoute path="*" token={tokenToUse} component={NotFound} exact />
        </Switch>
      </div>
    </>
  );
}

export default Routes;
